import type { NutritionQueueReceipt } from "@nova-ai/shared"
import type { BadgeTone } from "../ui/status-badge"

const OUTCOMES = {
  processing: { label: "In progress", tone: "info" },
  images_published: { label: "Images ready and published", tone: "success" },
  images_ready: { label: "Publication pending", tone: "info" },
  no_change: { label: "No change needed", tone: "muted" },
  withdrawn: { label: "Image withdrawn", tone: "muted" },
  unsupported: { label: "Unsupported", tone: "muted" },
  superseded: { label: "Superseded", tone: "muted" },
  unknown: { label: "Evidence incomplete", tone: "warning" },
  rejected: { label: "Rejected", tone: "destructive" },
  failed: { label: "Failed", tone: "destructive" },
  paused: { label: "Paused", tone: "warning" },
  delayed: { label: "Needs attention · delayed", tone: "warning" },
} satisfies Record<NutritionQueueReceipt["outcome"], { label: string; tone: BadgeTone }>
export function nutritionOutcome(outcome: NutritionQueueReceipt["outcome"]) {
  return OUTCOMES[outcome]
}
export function nutritionDuration(milliseconds: number | null) {
  if (milliseconds === null) {
    return "—"
  }
  const seconds = Math.floor(milliseconds / 1000)
  return `${Math.floor(seconds / 60)}m ${seconds % 60}s`
}
export const NUTRITION_STEPS = [
  { key: "received", title: "PIM event received", short: "Received" },
  { key: "generation", title: "Store images queued", short: "Queued" },
  { key: "upload", title: "Images made current", short: "Current image" },
  { key: "publication", title: "Published to Pub/Sub", short: "Pub/Sub" },
] as const
export const NUTRITION_VIEWS = [
  { key: "all", label: "All", count: "all" },
  { key: "in_progress", label: "In progress", count: "inProgress" },
  { key: "needs_attention", label: "Needs attention", count: "needsAttention" },
  { key: "done", label: "Done", count: "done" },
] as const
